import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-home-icon',
  templateUrl: 'home.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeIcon { }
